import React, { useEffect, useState } from 'react';
import { useParams, useHistory } from "react-router-dom";
import { useDispatch, useSelector, useStore } from 'react-redux';
// import * as _ from 'lodash';
import { Helmet } from "react-helmet";

import { API_URLS } from '../constants/apiUrls';
import { post } from '../utils/baseFetch';
import { setSite, setRejectReasonMessage } from '../reducers/siteSlice';
import { setQueueConfig, setRequestParams, setRequestTicketSuccessfully, setTagSequenceList, setCounterTagList } from '../reducers/queueSlice';
import { subscribeMqttTopic, unsubscribeMqttTopic, setLang } from '../reducers/systemSlice';
import { getQueuePageByStep } from '../utils/queueUtils';
import { getStringByTheme, showElementByTheme } from '../utils/utils';
import { QUEUE_REQUEST_PARAMS } from '../constants/initialStates';
import { PATH } from '../constants/paths';
import { NAVIGATION, ELEMENT, LANG, PATH_LOCATION } from '../constants/constants';
import { THEMES } from '../constants/themes';

import { SiteInfo } from '../components/SiteInfo';
import { GuluLogo } from '../components/GuluLogo';
import { QueueTitle } from '../components/QueueTitle';
import { BannerList } from '../components/BannerList';
import { DropDown } from '../components/DropDown';
import { TagSequence } from '../components/TagSequence';

// import { ReactComponent as ArrowIcon } from '../images/arrow.svg';
import { ReactComponent as CalendarIcon } from '../images/calendar.svg';
import { ReactComponent as QrcodeTicketIcon } from '../images/qrcode-ticket.svg';

import '../styles/site-detail.scss';
import moment from 'moment';

const Restaurant = () => {
  const params = useParams();
  const dispatch = useDispatch();
  const history = useHistory();
  const store = useStore();

  const site = useSelector((state) => state.site.site);
  const rejectReasonMessage = useSelector((state) => state.site.rejectReasonMessage);
  const tagSequenceList = useSelector((state) => state.queue.tagSequenceList);
  const lang = useSelector((state) => state.system.lang);
  const token = useSelector((state) => state.system.token);
  const theme = useSelector((state) => state.system.theme);
  const counterTagList = useSelector((state) => state.queue.counterTagList);
  const latestTag = useSelector((state) => state.queue.latestTag);

  // const [expandTagSequenceList, setExpandTagSequenceList] = useState(false);
  const [loading, setLoading] = useState(true);
  const [showQueueServiceTempUnavailable, setShowQueueServiceTempUnavailable] = useState(false);

  useEffect(() => {
    const mqttTopic = 'THEGULU/' + params.siteId + '/BATCH/#';
    dispatch(subscribeMqttTopic(mqttTopic));
    dispatch(subscribeMqttTopic('FOODGULU_V3/' + params.siteId + /MERCHANT/));

    if (params.language) {
      switch (params.language.toUpperCase()) {
        case LANG.EN:
        case LANG.SC:
          dispatch(setLang(params.language.toUpperCase()));
          break;
        default:
          dispatch(setLang(LANG.TC));
      }
    }

    return function unsubscribeMqtt() {
      // console.log('unsubscribeMqtt');
      const mqttTopic = 'THEGULU/' + params.siteId + '/BATCH/#';
      dispatch(unsubscribeMqttTopic(mqttTopic));
      if (tagSequenceList) {
        const timeSessionList = new Set();
        tagSequenceList.forEach((tagSequence) => {
          timeSessionList.add(tagSequence.timeSectionId);
        });
        timeSessionList.forEach((timeSessionId) => {
          dispatch(unsubscribeMqttTopic('FOODGULU_V3/' + params.siteId + '/' + timeSessionId));
        })
      }
    };
  }, []);

  useEffect(() => {
    document.title = getStringByTheme('siteTitle', lang, theme);
  }, [lang]);

  useEffect(() => {
    const searchParams = (new URL(document.location)).searchParams;
    if (!token && searchParams.get('qrcode')) {
      window.location = "thegulu://web?action=" + process.env.PUBLIC_URL + PATH.SITE_DETAIL + params.siteId + "&type=CAMPAIGN";
    }
  }, [params.siteId]);

  useEffect(() => {
    const newParams = { siteId: params.siteId };
    post(API_URLS.SITE, newParams, (payload) => {
      if (payload.name) {
        document.title = payload.name;
      }
      dispatch(setQueueConfig(undefined));
      dispatch(setSite(payload));
      dispatch(setTagSequenceList({
        siteId: params.siteId,
        tagSequenceList: (payload.tagList) ? payload.tagList : []
      }));
      dispatch(setCounterTagList({
        siteId: params.siteId,
        counterTagList: (payload.counterTagList) ? payload.counterTagList : []
      }));

      if (payload.webRejectReasonDto) {
        if (payload.webRejectReasonDto.rejectReason) {
          dispatch(setRejectReasonMessage(payload.webRejectReasonDto.rejectReason));
          setShowQueueServiceTempUnavailable(false);
        } else if (theme === THEMES.TESTING_CENTRE || theme === THEMES.LEAVE_HOME_SAFE) {
          const currentTime = Date.now();
          const preparingTime = payload.webRejectReasonDto.dailyResetTimestamp && currentTime >= payload.webRejectReasonDto.dailyResetTimestamp && payload.webRejectReasonDto.firstSectionStartTimestamp && currentTime < payload.webRejectReasonDto.firstSectionStartTimestamp;
          const initialTagTicketSequence = payload.tagList && payload.tagList.every((tagSequence) => {
            return tagSequence.start === 0 && tagSequence.end === 0 && tagSequence.ticketSequence === 0;
          })
          if (preparingTime && initialTagTicketSequence) {
            dispatch(setRejectReasonMessage(getStringByTheme('queueServiceTempUnavailable', lang, theme)));
            setShowQueueServiceTempUnavailable(true);
          } else {
            dispatch(setRejectReasonMessage(''));
            setShowQueueServiceTempUnavailable(false);
          }
        }
      } else {
        dispatch(setRejectReasonMessage(''));
        setShowQueueServiceTempUnavailable(false);
      }

      if (payload.tagList) {
        const timeSessionList = new Set();
        payload.tagList.forEach((tagSequence) => {
          timeSessionList.add(tagSequence.timeSectionId);
        });
        // console.log('timeSessionList', timeSessionList);
        timeSessionList.forEach((timeSessionId) => {
          // dispatch(subscribeMqttTopic('THEGULU/' + params.siteId + '/BATCH/' + timeSessionId));
          dispatch(subscribeMqttTopic('FOODGULU_V3/' + params.siteId + '/' + timeSessionId));
        })
      }
      // dispatch(subscribeMqttTopic('FOODGULU_V3/' + params.siteId + '/A'));
      // dispatch(subscribeMqttTopic('FOODGULU_V3/' + params.siteId + '/B'));
      setLoading(false);
    }, undefined, store);
  }, [params.siteId, dispatch, store, lang]);

  function handleQueueClick() {
    if (site.firstStep) {
      dispatch(setRequestParams(QUEUE_REQUEST_PARAMS));
      dispatch(setRequestTicketSuccessfully(false));
      history.push(getQueuePageByStep(site.firstStep) + params.siteId);
    }
  }

  // function handleExpandTagSequenceListClick() {
  //   setExpandTagSequenceList(!expandTagSequenceList);
  // }

  function handleNavigationClick(navigation) {
    switch (navigation) {
      case NAVIGATION.PRE_REGISTRATION:
        handleQueueClick();
        break;
      case NAVIGATION.MOBILE_QUEUE:
        window.location = "https://www.thegulu.com/download.html?redirect_rest=restUrlId=" + params.siteId + " &from=web&action=QUEUE";
        break;
      default:
    }
  }

  return (
    <>
      {
        site && !loading &&
        <>
          <div className="site-detail-wrapper">
            <Helmet>
              <title>{site.name}</title>
              <meta name="description" content={site.name} />
              <meta property="og:title" content={site.name} />
              <meta property="og:description" content={site.name} />
            </Helmet>
            <GuluLogo show={!token} showLang={!token} />
            <div className="background-site-info background-site-info-head">
              <SiteInfo site={site} show={!token} showLang={!token} location={PATH_LOCATION.SITE_DETAIL_MAP}/>
            </div>
            <div className="background-site-info-body">
            {
              rejectReasonMessage &&
              <div className="reject-reason">{rejectReasonMessage}</div>
            }
            {
              showElementByTheme(ELEMENT.SITE_DETAIL_NAVIGATION_LIST_TOP, theme) && !params.ticketId &&
              <div className="navigation-list">
                {
                  site.firstStep &&
                  <div className="navigation-button pre-reg"
                    onClick={() => { handleNavigationClick(NAVIGATION.PRE_REGISTRATION); }}>
                    {
                      showElementByTheme(ELEMENT.SITE_DETAIL_NAV_PRE_REG_ICON, theme) &&
                      <CalendarIcon className='image pre-reg' />
                    }
                    {
                      showElementByTheme(ELEMENT.SITE_DETAIL_NAV_QRCODE_ICON, theme) &&
                      <QrcodeTicketIcon className='image qrcode' />
                    }
                    <span>{getStringByTheme('preRegistration', lang, theme)}</span>
                  </div>
                }
                {
                  showElementByTheme(ELEMENT.SITE_DETAIL_MOBILE_QUEUE, theme) && site.mobileQueueAvailable &&
                  <div className="navigation-button request-ticket"
                    onClick={() => { handleNavigationClick(NAVIGATION.MOBILE_QUEUE); }}>
                    {/* <QrcodeTicketIcon className='image' /> */}
                    <img className="image" src={process.env.PUBLIC_URL + "/images/gulu-logo.png"} alt="thegulu" />
                    <span>{getStringByTheme('mobileRequestTicket', lang, theme)}</span>
                  </div>
                }
              </div>
            }
            {
              showElementByTheme(ELEMENT.SITE_DETAIL_COUNTER_TAG_LIST, theme) &&
              <div className="background-site-info tag-sequence-list-wrapper">
                <div className="title">{getStringByTheme('currentTagSequence', lang, theme)}</div>
                {
                  counterTagList && counterTagList.length > 0 &&
                  <div className="counter-tag-list">
                    {
                      counterTagList.map((counterTag, counterTagKey) => {
                        return (
                          <TagSequence key={counterTagKey} tagSequence={counterTag} latestTag={latestTag} />
                        )
                      })
                    }
                  </div>
                }
              </div>
            }
            {
              showElementByTheme(ELEMENT.SITE_DETAIL_TAG_SEQUENCE_LIST, theme) &&
              tagSequenceList && tagSequenceList.length > 0 &&
              <div className="background-site-info tag-sequence-list-wrapper">
                <div className="current-date">{moment().format('YYYY-MM-DD dddd')}</div>
                <div className="title">{getStringByTheme('currentTagSequence', lang, theme)}</div>
                <div className="tag-sequence-list">
                  {
                    // ((expandTagSequenceList) ? tagSequenceList : _.take(tagSequenceList, 3)).map((tagSequence, tagSequenceKey) => {
                    tagSequenceList.map((tagSequence, tagSequenceKey) => {
                      return (
                        <TagSequence key={tagSequenceKey} tagSequence={tagSequence} showQueueServiceTempUnavailable={showQueueServiceTempUnavailable} />
                      )
                    })
                  }
                </div>
                {/* {
                  tagSequenceList.length > 3 &&
                  <div className={"expand-button " + ((expandTagSequenceList) ? 'collapse' : 'expand')} onClick={handleExpandTagSequenceListClick}>
                    <ArrowIcon className={"drop-down-image " + ((expandTagSequenceList) ? "change" : "")} />
                    <span>{getStringByTheme((expandTagSequenceList) ? 'collapse' : 'expand', lang, theme)}</span>
                  </div>
                } */}
              </div>
            }
            {
              showElementByTheme(ELEMENT.SITE_DETAIL_QUEUE_TITLE, theme) &&
              <QueueTitle title={site.title} />
            }
            {
              showElementByTheme(ELEMENT.SITE_DETAIL_BANNER_LIST, theme) &&
              <BannerList bannerList={site.bannerList} displayUnderLine />
            }
            {
              showElementByTheme(ELEMENT.SITE_DETAIL_NAVIGATION_LIST_BOTTOM, theme) && !params.ticketId &&
              <div className="navigation-list">
                {
                  site.firstStep &&
                  <div className="navigation-button pre-reg"
                    onClick={() => { handleNavigationClick(NAVIGATION.PRE_REGISTRATION); }}>
                    {
                      showElementByTheme(ELEMENT.SITE_DETAIL_NAV_PRE_REG_ICON, theme) &&
                      <CalendarIcon className='image pre-reg' />
                    }
                    {
                      showElementByTheme(ELEMENT.SITE_DETAIL_NAV_QRCODE_ICON, theme) &&
                      <QrcodeTicketIcon className='image qrcode' />
                    }
                    <span>{getStringByTheme('preRegistration', lang, theme)}</span>
                  </div>
                }
                {
                  showElementByTheme(ELEMENT.SITE_DETAIL_MOBILE_QUEUE, theme) && site.mobileQueueAvailable &&
                  <div className="navigation-button request-ticket"
                    onClick={() => { handleNavigationClick(NAVIGATION.MOBILE_QUEUE); }}>
                    {/* <QrcodeTicketIcon className='image' /> */}
                    <img className="image" src={process.env.PUBLIC_URL + "/images/gulu-logo.png"} alt="thegulu" />
                    <span>{getStringByTheme('mobileRequestTicket', lang, theme)}</span>
                  </div>
                }
              </div>
            }
            <div className="detail-wrapper">
              {
                site.descriptionList && site.descriptionList.map((description, index) => {
                  return (
                    <DropDown
                      key={index}
                      titleClass="ticket-title"
                      title={description.TITLE}
                      content={description.CONTENT}
                      location={PATH_LOCATION.SITE_DETAIL}
                    />
                  )
                })
              }
            </div>
          </div>
          </div>
          {
            showElementByTheme(ELEMENT.SITE_DETAIL_BOTTOM_BUTTON, theme) &&
            <div className="bottom-btn-wrapper">
              <div className={"queue-button" + ((!site.firstStep) ? " disable" : "")} onClick={handleQueueClick}>{getStringByTheme('requestTicket', lang, theme)}</div>
            </div>
          }
        </>
      }
    </>
  );
}

export default Restaurant;
